// ng build --env=prod
export const environment = {
  protocol: "https",
  production: true,
  host: "containerservices.inlandservices.com",
  host_inland: "containerservices.inlandservices.com",
  host_moduleCSL: "maersk-apmtis-appser-csl-modulecsl-prod.azurewebsites.net",
  host_login_csl: "containerservicesfull.inlandservices.com",
  url_form: "https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLaXnDy7MWe9KpaLOM78-Z6xUOUkxT1JSWTRVVkhXNkpVNzRZNFM0QUVIVi4u",
  rest: "/api/",
  systemId: 5,
  version: "2.0.2"
};


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/environments/environment.ts